// src/pages/History/EarlyModern/ColumbianExchangeGo.jsx
import React from 'react';
import QuizPage from '../../../components/QuizPageNew2';
import historyImage from '../../../assets/history2/Early_Modern_Period_-_Columbian_Exchange.png';

function HistoryPageColumbianExchangeGo() {
  return (
    <QuizPage
      title="History: Columbian Exchange"
      subTopic="Columbian Exchange"
      backgroundImage={historyImage}
      returnPath="/History-Columbian-Exchange"
    />
  );
}

export default HistoryPageColumbianExchangeGo;
